import React from 'react';
import { Link } from 'react-router-dom';
 
class Content extends React.Component {
    render(){
        return (
            <section className="blog-area ptb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img1.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">The best gear for starting Link small business</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img2.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">Get your first business suit right with these tips</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img3.jpg")})`}}
                            >
                                <span>Design & IT</span>
                                <h4><Link to="/blog-details">How to Make Link Font - Font Design Full Process</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img4.jpg")})`}}
                            >
                                <span>Marketing & Trend</span>
                                <h4><Link to="/blog-details">10 Hot Marketing Trends You Need to Implement in 2018</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img5.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">How to Be Link Work From Home Professional</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img1.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">The best gear for starting Link small business</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img2.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">Get your first business suit right with these tips</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img3.jpg")})`}}
                            >
                                <span>Design & IT</span>
                                <h4><Link to="/blog-details">How to Make Link Font - Font Design Full Process</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img4.jpg")})`}}
                            >
                                <span>Marketing & Trend</span>
                                <h4><Link to="/blog-details">10 Hot Marketing Trends You Need to Implement in 2018</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                            
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img5.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">How to Be Link Work From Home Professional</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item" 
                                style={{backgroundImage: `url(${require("../../assets/images/services-img5.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">How to Be Link Work From Home Professional</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div 
                                className="single-blog-item"
                                style={{backgroundImage: `url(${require("../../assets/images/services-img5.jpg")})`}}
                            >
                                <span>Business & Tech</span>
                                <h4><Link to="/blog-details">How to Be Link Work From Home Professional</Link></h4>
                                <p> Fusce vitae nulla at lorem pret ium semper. Curab itur laoreet, lectus ac digni ssim vest ibul lorem pretium semper lectus ac digni...</p>
                                
                                <Link to="/blog-details" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Content;